"use strict";

export default class MyChampsController
{
	/*@ngInject*/
	constructor($http, $stateParams)
	{
		this.viewPromise = $http.post("/api/backend/champs")
		.then(response =>
		{
			this.champs = response.data;
			//console.log(response.data);
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/champs/mychamps.controller.js